import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { FiChevronDown } from "react-icons/fi";
import avatar from "@/assets/avatar.jpeg";

export const guardianAvatar = (guardian: any) =>
  guardian?.driveid
    ? guardian.driveid.includes("https://")
      ? guardian.driveid
      : `https://drive.google.com/uc?id=${guardian.driveid}&export=download`
    : avatar;

export const guardianName = (guardian: any) =>
  guardian?.displayname ||
  [guardian?.firstname, guardian?.lastname].filter(Boolean).join(" ");

const NavItemImage = (props: any) => {
  const guardian: any = useSelector((state: any) => state.Parent?.guardian);
  const ref = useRef<HTMLLIElement>(null);
  const { isOpen, onToggle, onClose } = props;

  // Close on outside click or Escape
  useEffect(() => {
    if (!isOpen) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  const name = guardianName(guardian);

  return (
    <li ref={ref} className="position-relative d-flex align-items-center">
      <button
        type="button"
        aria-haspopup="menu"
        aria-expanded={isOpen}
        aria-label="Account menu"
        onClick={onToggle}
        className="btn d-flex align-items-center gap-2 text-white border-0 p-1"
        style={{
          borderRadius: 999,
          paddingInlineEnd: 10,
          backgroundColor: isOpen ? "rgba(255, 255, 255, 0.18)" : "transparent",
          transition: "background-color 150ms",
        }}
      >
        <img
          alt=""
          src={guardianAvatar(guardian)}
          width={34}
          height={34}
          className="rounded-circle"
          style={{
            objectFit: "cover",
            boxShadow: "0 0 0 2px #ffbd30",
          }}
        />
        {name && (
          <span
            className="d-none d-lg-inline fw-semibold text-truncate"
            style={{ maxWidth: 140, fontSize: 14 }}
          >
            {name}
          </span>
        )}
        <FiChevronDown
          aria-hidden="true"
          style={{
            transition: "transform 200ms",
            transform: isOpen ? "rotate(180deg)" : "none",
          }}
        />
      </button>
      {isOpen && props.children}
    </li>
  );
};

export default NavItemImage;
